import styled, { css } from 'styled-components';

import { ANIM, HOME } from '../../../../theme/tokens';
import { hoverWash, pulseCard } from '../../../../theme/mixins';
import { Text } from '../../../../components';

/** The metric card surface — the source `.metric-card.card`. `pulseCard` is that
 *  exact surface (32%-black wash over zinc-900, hairline border, 16px radius). */
export const Frame = styled.div<{ $clickable?: boolean }>`
  ${pulseCard}
  padding: 10px;
  min-width: 0;
  ${(p) =>
    p.$clickable &&
    css`
      cursor: pointer;
      outline: none;
      ${hoverWash}
    `}
`;

/** The drill-in chevron at the head's right (the score gauges' arrow), nudged right while the card is hovered. */
export const Chev = styled.span`
  flex: none;
  display: grid;
  place-items: center;
  transition: transform ${ANIM.INTERACT_MS}ms ${HOME.ease};

  ${Frame}:hover & {
    transform: translateX(2px);
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 5px 4px;
`;

export const HeadText = styled.div`
  min-width: 0;
`;

export const Title = styled(Text)`
  display: block;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: ${HOME.t300};
`;

export const Sub = styled(Text)`
  display: block;
  font-size: 14px;
  font-weight: 300;
  color: ${HOME.t300};
  margin-top: 4px;
`;
